import React from 'react';
import { useController } from './provider';

export const FieldEditor = () => {
    const { renderFieldEditor, isEditing } = useController();
    return !isEditing ? null : renderFieldEditor();
};
